//@flow
import * as React from 'react'
import { useReducer, useContext, useEffect } from 'react'

import initialState from './initialState'
import reducer from './reducer'

import type { GlobalContextState, GlobalContextDispatch } from './types.flow'

const GlobalContext = React.createContext<GlobalContextState>(initialState)
const GlobalDispatch = React.createContext<GlobalContextDispatch | void>()

type GlobalContextProviderProps = {
  children: React.Node
}

const GlobalContextProvider = ({ children }: GlobalContextProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  // For debugging purposes only
  useEffect(() => {
    window.getGlobalContext = key => state[key] || state
  }, [state])

  return (
    <GlobalContext.Provider value={state}>
      <GlobalDispatch.Provider value={dispatch}>{children}</GlobalDispatch.Provider>
    </GlobalContext.Provider>
  )
}

const useGlobalContext = () => {
  const context = useContext(GlobalContext)
  if (!context) {
    throw new Error('[GlobalContext] useGlobalContext must be used within GlobalContextProvider')
  }
  return context
}

const useGlobalDispatch = () => {
  const context = useContext(GlobalDispatch)
  if (!context) {
    throw new Error('[GlobalContext] useGlobalDispatch must be used within GlobalContextProvider')
  }
  return context
}

export { useGlobalContext, useGlobalDispatch, GlobalContextProvider }
